import React from 'react';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import styles from './AddressInformations.module.sass';

const AddressInformations = ({ company, onCompanyChange }) => {
  return (
    <Card className={styles.card} title="Adresse de l'entreprise" classTitle="title-green">

      <div className={styles.group}>

        <TextInput
          className={styles.field}
          label="Adresse complète"
          name="address"
          type="text"
          value={company?.address || ''}
          onChange={onCompanyChange}
          required
        />
        <TextInput
          className={styles.field}
          label="Complément d'adresse"
          name="address_complement"
          type="text"
          value={company?.address_complement || ''}
          onChange={onCompanyChange}
        />
        <TextInput
          className={styles.field}
          label="Code postal"
          name="zip_code"
          type="text"
          value={company?.zip_code || ''}
          onChange={onCompanyChange}
          required
        />
        <TextInput
          className={styles.field}
          label="Ville"
          name="city"
          type="text"
          value={company?.city || ''}
          onChange={onCompanyChange}
          required
        />
        <TextInput
          className={styles.field}
          label="Département"
          name="department"
          type="text"
          value={company?.department || ''}
          onChange={onCompanyChange}
        />
        <TextInput
          className={styles.field}
          label="Pays"
          name="country"
          type="text"
          value={company?.country || 'France'}
          onChange={onCompanyChange}
          required
        />
      </div>
    </Card >
  );
};

export default AddressInformations;
